import { Reducer } from 'redux'
import Cookies from 'universal-cookie'
import _ from 'lodash'
import * as actions from './actions'
import { Hook, HookValidationResult, HookValidationParameters } from './types'

export const cookies = new Cookies()

export type HookState = Readonly<{
  hooks: Record<string, Hook>
  isValidating: boolean
  isSaving: boolean
  validationResult: HookValidationResult | null
  selectedHook: HookValidationParameters | null
}>

export const initState: HookState = {
  hooks: {},
  isValidating: false,
  isSaving: false,
  validationResult: null,
  selectedHook: null
}

// reducer
export const hookReducer: Reducer<HookState, actions.HookActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_HOOKS_SUCCESS:
      return {
        ...state,
        hooks: { ..._.keyBy(action.payload, 'id') }
      }
    case actions.START_HOOK_VALIDATION:
      return {
        ...state,
        isValidating: true
      }
    case actions.UPDATE_HOOK_VALIDATION:
      return {
        ...state,
        validationResult: action.payload,
        isValidating: false
      }
    case actions.UPDATE_NEW_HOOK:
      return {
        ...state,
        selectedHook: action.payload.hook
      }
    case actions.RESET_NEW_HOOK:
      return {
        ...state,
        selectedHook: null
      }
    case actions.START_SAVING_HOOK:
      return {
        ...state,
        isSaving: true
      }
    case actions.SAVING_HOOK_SUCCESS:
      return {
        ...state,
        isSaving: false
      }
    case actions.FETCH_HOOK_INFO:
      return {
        ...state,
        isLoading: true
      }
    case actions.FETCH_HOOK_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedHook: action.payload.hook
      }
    default:
      return state
  }
}
